import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  latestProjects = [
    {
      name: 'Path Finder Visualizer',
      about: 'Graph algorithms might feel scary if one lacks imagination and therefore to remedy this problem, this project helps in visualizing some of the most important searching algorithms.',
      link: 'https://adityavandan.github.io/mechtechmeet2020/',
      github_link: 'https://github.com/AdityaVandan/pathfinder/'
    },
    {
      name: 'Mech Tech Meet Event Website',
      about: 'This is an event website which was created for the Ujjain Engineering College Tech Festival. This website was made using technologies Javascript,PHP',
      link: 'https://adityavandan.github.io/mechtechmeet2020/',
      github_link: 'https://github.com/AdityaVandan/mechtechmeet2020'
    }
  ];
  projects = [
    {
      key:'5',
      name: 'Path Finder Visualizer',
      about: 'Graph algorithms might feel scary if one lacks imagination and therefore to remedy this problem, this project helps in visualizing some of the most important searching algorithms namely, bfs, dfs, dijkstra, greedy BST, A* and swarm which are used in solving graphs and mazes for the shortest path. This also provides another feature of maze generation in a 2-d Grid. Technologies used: JavaScript, React',
      link: 'https://adityavandan.github.io/path-finder/',
      github_link: 'https://github.com/AdityaVandan/path-finder/',
      image_path: 'pathfinder.jpg',
      demoPossible: true
    },
    {
      key:'1',
      name: 'NAF Generic Socket Framework for Java',
      about: 'It is a java based framework designed to simplify the process of establishing a network between application modules. It serves thepurpose of network between different modules of a program/application for negating the need for writing code for socket programming at the server and client end. The resources used were: Java1.8, Reflection API, Gradle',
      link: 'https://adityavandan.github.io/mechtechmeet2020/',
      github_link: 'https://github.com/AdityaVandan/Network-Application-Framework',
      image_path: 'naf.jpg',
      demoPossible: false
    },
    {
      key:'2',
      name: 'Data Modeller for SQL',
      about: 'It is a web based graphical tool that enhances productivity and simplifies data modeling tasks. This Data Modeller serves three purposes: Firstly, For designing database tables and their relationship diagrams in a project. Secondly, SQL script generation of the tables designed.Thirdly, Generation of data layer as Hibernate’s Plain Old Java Objects(POJO). Resources used: Java1.10, Tomcat9, MySQL, Bootstrap, HTML, CSS, JavaScript, web services, ORMFramework',
      link: '',
      github_link: 'https://github.com/AdityaVandan/TMDModeller',
      image_path: 'dataModeller.jpg',
      demoPossible: false
    },
    {
      key:'3',
      name: 'Mech Tech Meet Event Website',
      about: 'This is an event website which was created for the Ujjain Engineering College Tech Festival. This website was made using technologies Javascript,PHP',
      link: 'https://adityavandan.github.io/mechtechmeet2020/',
      github_link: 'https://github.com/AdityaVandan/mechtechmeet2020',
      image_path: 'mtm.jpg',
      demoPossible: true
    },
    {
      key:'4',
      name: 'Team Viewer Replica',
      about: 'It is Java based application in which server system can share screen as well as files with a client system while sharing data on TCP & FTP. Resources used: java.io and java.net packages',
      link: '',
      github_link: 'https://github.com/AdityaVandan/team-viewer',
      image_path: 'team-viewer.jpg',
      demoPossible: false
    }
  ];
  getLatestProjects() {
    return this.latestProjects;
  }
  getProjects() {
    return this.projects;
  }
  constructor() { }
}
